<template>
  <div
    class="photo-swipe-gallery | pswp"
    ref="mainFullScreenGallery"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    v-if="initPhotoSwipe"
  >
    <div class="pswp__bg" />
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item" />
        <div class="pswp__item" />
        <div class="pswp__item" />
      </div>
      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter" />
          <button
            class="pswp__button pswp__button--close"
            :title="returnButtonLabel('close')"
          />
          <button
            class="pswp__button pswp__button--fs"
            :title="returnButtonLabel('toggle')"
          />
          <button
            class="pswp__button pswp__button--zoom"
            :title="returnButtonLabel('zoom')"
          />
          <button
            class="pswp__button pswp__button--share"
            title="Share"
          />
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut" />
              </div>
            </div>
          </div>
        </div>
        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip" />
        </div>
        <button
          class="pswp__button pswp__button--arrow pswp__button--arrow--left"
          :title="returnButtonLabel('arrowLeft')"
        />
        <button
          class="pswp__button pswp__button--arrow pswp__button--arrow--right"
          :title="returnButtonLabel('arrowRight')"
        />
        <div class="pswp__caption">
          <div class="pswp__caption__center" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // HTML structure is required by PhotoSwipe
  import productPageStateComputedMixin from '../../utilities/vueMixins/productPageStateComputedMixin/productPageStateComputedMixin.js';
  import PhotoSwipe from 'photoswipe/dist/photoswipe.js';
  import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'
  import YoutubePlayer from "../../utilities/js/youtubePlayer/youtube";
  import {breakpoints} from "../../variables/variables";

  export default {
    mixins: [
      productPageStateComputedMixin
    ],
    props: {
      id: String,
      productName: String
    },
    data() {
      return {
        yt: new YoutubePlayer(this.$t("global.swiper.video.title.text")),
        isMobile: window.innerWidth < breakpoints.tablet,
      };
    },
    created() {
      window.addEventListener('breakpointChange', this.breakpointChangeHandler.bind(this));
      this.$store.subscribe(mutation => {
        if (mutation.type === 'productPage/initPhotoSwipe') {
          this.initGallery(this.currentGalleryIndex)
        }
      });
    },
    mounted() {
      window.addEventListener('breakpointChange', this.breakpointChangeHandler.bind(this));
    },
    methods: {
      initGallery(index) {
        let options = {
          index: index,
          showHideOpacity: true,
          bgOpacity: 0.8,
          spacing: 0.1,
          shareEl: false,
          closeEl: true,
          captionEl: true,
          fullscreenEl: true,
          zoomEl: true,
          loop: false,
          history: false,
          preloaderEl: false,
          preload: [1,1]
        }

        let items = this.images.map((image, index) => {
          let playerId = `youtube-player-${index}`;
          return image.videoId
            ? {
              html: `<div id="${playerId}"></div>`,
              title: "Youtube Video zum Produkt " + this.productName,
              playerId: playerId,
              youtubeVideoId: image.videoId,
              index: index
            }
            : {
              src: image.zoom,
              msrc: image.big,
              title: this.productName,
              w: 1700,
              h: 1000
            };
        });

        this.gallery = new PhotoSwipe( this.$refs.mainFullScreenGallery, PhotoSwipeUI_Default, items, options);
        this.gallery.init();

        this.gallery.listen('unbindEvents', () => {
          let getCurrentIndex = this.gallery.getCurrentIndex();
          this.$store.dispatch('productPage/indexUpdate', getCurrentIndex);
        });

        let that = this;
        this.gallery.listen('gettingData', function(index, item) {
          Array.from(document.getElementsByClassName('pswp__img')).forEach((el) => {
            el.alt = that.$t('global.pdp.big.image.alt.prefix', [index, item.title]);
          });
        });

        let vm = this;
        this.gallery.listen('afterChange', function() {
          vm.yt.reset();
          if (this.currItem.youtubeVideoId) {
            this.currItem.width = 1700;
            this.currItem.height = vm.isMobile ? 300 : 1000;
            vm.yt.handlePlay(this.currItem);
          }
        });
      },
      returnButtonLabel(label) {
        let buttonTitle;

        switch (label) {
        case 'toggle':
          buttonTitle = this.$t('photoSwipe.toggle');
          break;
        case 'close':
          buttonTitle = this.$t('photoSwipe.close');
          break;
        case 'zoom':
          buttonTitle = this.$t('photoSwipe.zoom');
          break;
        case 'arrowLeft':
          buttonTitle = this.$t('photoSwipe.arrowLeft');
          break;
        case 'arrowRight':
          buttonTitle = this.$t('photoSwipe.arrowRight');
          break;
        }

        return buttonTitle;
      },
      breakpointChangeHandler() {
        this.isMobile = window.innerWidth < breakpoints.tablet;
      },
    },
    computed: {
      images() {
        return this.productDetails.images;
      }
    }
  };

</script>
